import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FavoritesService } from './favorites.service';

@Component({
    selector: 'app-favorite-star',
    templateUrl: './favorite-star.component.html',
    styleUrls: ['./favorite-star.component.scss']
})
export class FavoriteStarComponent implements OnInit {
    @Input() dataItem;
    @Input() listType: string;

    public isFavoritesAvailable: boolean = false;

    constructor(private favoritesService: FavoritesService,
        private cdRef: ChangeDetectorRef) {
        this.isFavoritesAvailable = this.favoritesService.isFavoritesAvailable;
    }

    ngOnInit(): void { }

    public toggleFavorite(event) {
        event.stopPropagation();
        event.preventDefault();
        this.dataItem['Favorite'] ? this.deleteFavorite() : this.addFavorite();
    }

    public addFavorite() {
        let url = `${this.getApiUrl()}/SetAsFavorite`;

        this.favoritesService.addFavorite(url).subscribe({
            next: (res) => {
                this.dataItem['Favorite'] = true;
                this.cdRef.markForCheck();
            },
            error: (error) => {
                console.log('error', error);
            }
        });
    }

    public deleteFavorite() {
        let url = `${this.getApiUrl()}/RemoveFromFavorites`;

        this.favoritesService.deleteFavorite(url).subscribe({
            next: (res) => {
                this.dataItem['Favorite'] = false;
                this.cdRef.markForCheck();
            },
            error: (error) => {
                console.log('error', error);
            }
        });
    }

    public getApiUrl() {
        let url = '';
        switch (this.listType) {
            case 'Tasks':
                url = 'Api';
                break;
            case 'Worksites':
                url = 'WorksiteApi';
                break;
            case 'Plans':
                url = 'PlanApi';
                break;
            case 'InvoicingProposals':
                url = 'InvoicingProposalApi';
                break;
            case 'Tenderings':
                url = 'TenderingApi';
                break;
        }

        if (this.listType === 'Plans') {
            return `${url}/${this.listType}(${this.dataItem.Id})`;
        } else {
            return `${url}/${this.listType}/${this.dataItem.Id}`;
        }
    }

}
